import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { PartnerLogoComponent, SecondaryLogoComponent } from '@partners/kernel';
import { ThemeAssetComponent } from '@partners/themes';
import { AppCloseDirective } from '../../directives';

@Component({
  selector: 'application-header',
  standalone: true,
  imports: [ThemeAssetComponent, AppCloseDirective, PartnerLogoComponent, SecondaryLogoComponent],
  template: `
    
    <secondary-logo />
  
    <partner-logo />
    
    <div class="exit-button">
      <button tabindex="-1" mat-icon-button type="button" aria-label="יציאה" applicationClose>
        <theme-asset asset="close-icon"></theme-asset>
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'application-header'
  }
})
export class ApplicationHeaderComponent {}
